/* pXXX where the p represents 'parameter' */
export const pInputSource = {
  WEBCAM: 0,       
  VIDEO: 1, 
}


export const pCustomFilter = {
  OFFSET: 0,       
  FRAMING: 1, 
  KPS: 2, 
  CONTROL: 3, 
  VIRTUALBG: 4 
}


export const pCommProviderSelection = {
  SERVER: 0,        // UP SERVER    & UP FIREBASE
  SERVER_BACKUP: 1, // DOWN SERVER  & UP SERVER CLOUD
}

export const pMediapipeHandDetected = {
  NONE: 0,
  RIGHT: 1,
  LEFT: 2,
  BOTH: 3
}


export const pRemoteControlOptions = {
  ULTRA: 50,    // steps of 50
  FAST: 25,     // steps of 25
  NORMAL: 15,   // steps of 15
  SLOW: 5,      // steps of 5
}

export const pRepetitionRecord = {
  NO_REPEAT: 0,
  ONE_REPETITION: 1,
  LOOP: 2,
}

export const speedCountDownTimer = [ 0.5, 1, 2, 4]


export const pDonateSignButtonsOptions = {
  NEXT: 'NEXT',
  REPEAT: 'REPEAT',
  DISCARD: 'DISCARD',
}

/* Video Recording Time */
export const pRecordTime = {
  default: 3,
  max: 5,
  step: 1,
  min: 2,
  /* Countdown timer */
  countdown: 3,
};

/* Video recorder */

export const pRecordVideo = {
  video: {
    frameRate: 60,
    // width: 2880,
    // height: 2160,
    width: 640,
    height: 480,
  },
  //video: true,
  audio: false,
  blobPropertyBag: { type: "video/mp4" },
};

export const pRecordVideoPortrait = {
  video: {
    frameRate: 60,
    // width: 2160,
    // height: 2880,
    width: 480,
    height: 640,
  },
  //video: true,
  audio: false,
  blobPropertyBag: { type: "video/mp4" },
};

export const pRecordVideoSquare = {
  /*video: {
    aspectRatio: 1,
  },*/
  video: true,  
  audio: false,
  blobPropertyBag: { type: "video/mp4" },
};

/* Webcam */
export const pWebcam = {
  audio: false,
  mirrored: true,
};

/* Video constraints */
/*
4:3 aspect ratio resolutions: 640×480, 800×600, 960×720, 1024×768, 1280×960, 
1400×1050, 1440×1080 , 1600×1200, 1856×1392, 1920×1440, and 2048×1536. 

*** Since we will cut the video to a 1:1 aspect ratio after sending it to the server, we can ask for any aspect ratio from the webcam.
    Most webcams use an aspect ratio of 16:9, but most phones have a default aspect ratio of 4:3, so we'll keep using it, but it's worth mentioning, in case 
    we want to prioritize one or the other. ***
*/
export const pVideoConstraints = {
  frameRate: 60,
  width: 640,
  height: 480,
  // width: 2880,
  // height: 2160,
  aspectRatio:  1.3333,
  //facingMode: "user",
};

export const pVideoConstraintsPortrait = {
  frameRate: 60,
  // width: 2160,
  // height: 2880,
  width: 480,
  height: 640,

  aspectRatio:  0.75,
  //facingMode: "user",
};

export const pVideoConstraintsSquare = {
  //aspectRatio: 1,
  video: true,  
  //facingMode: "user",
};

/* Server */
export const pServer = {
  /* Server address */
  
  server_url: "https://lse.mvazquez.es:8443/main",
  server_url_data: "https://lse.mvazquez.es:8443/data_main",

  // server_url: "https://lse.mvazquez.es:8443/beta",
  // server_url_data: "https://lse.mvazquez.es:8443/data_beta",
  

  // server_url: "https://lse.gts.uvigo.es:56076/main",
  // server_url_data: "https://lse.gts.uvigo.es:56076/data_main",

  server_backup_url: "https://lse2.mvazquez.es/main",
  server_backup_url_data: "https://lse2.mvazquez.es/data_main",

  // base_url: "http://localhost:56076",
  timeout: 600000,
  /* Response Fields */
  video_id: "video_id",
  sign_id: "predictions",
  name: "signs",
  def: "definitions",
  url: "urls",
  url_sign: "url_vid_sign",
  url_def: "url_vid_definition",
  prob: "probabilities",
  /* Request Fields */
  form_sign: "sign_id",
  form_uid: "user_id",
  form_video: "file",
  form_device: "device",
  form_type: "type",
  /* Browser info */
  form_browser: "browser",
  form_webcam: "webcam",
  form_origin: "origin",
  form_web: "web",
  /* DataBuilder */
  form_session: "session",
  form_filename: "filename",
  form_class_id: "class_id",
  form_annotation_code_id: "annotation_code_id",
  form_comment: "comment",
  form_counter_repeats_used: "counter_repeats_used",
  form_history_log: "history_log",
  /* Feedback */
  form_video_id: "video_id",
  form_feedback_lemma: "feedback_lemma",
  form_feedback_meaning: "feedback_meaning",
  form_feedback_gloss: "feedback_gloss",
  form_feedback_sign_uid: "feedback_sign_uid",
  /* ReportBug */
  form_titleBug: "title",
  form_bodyBug: "body",
  form_labelsBug: "labels",

  /*Records */
  form_record_id : "record_id",

  /* VersusMachine */
  form_elements_requested: "elements_requested",
  form_elements_response: "elements_response",
  form_elements_requested: "elements_requested",
  form_elements_response: "elements_response",


  form_arr_gloss_id: "arr_gloss_id",
  form_lemmas_request: "arr_lemmas_request",
  form_lemmas_annotated: "arr_lemmas_annotated",
  form_hits: "hits",
  form_arr_counter_repeats: "arr_counter_repeats",
  form_duration: "duration",

  /*Create Teams*/
  form_team_id: 'team_id',
  form_team_label: 'label',
  form_team_imgBase64: 'imgBase64',
  form_team_email: 'email',
  form_team_school: 'school',
  form_team_zip_code: 'zip_code',
  form_team_information: 'information',

  form_task_id: 'task_id',
  form_task_arr_elements: 'arr_elements',
  form_deadlineTimestamp: 'deadline_timestamp',

  form_team_user_id: 'user_id',

  /*Submission*/
  form_submission_reference: 'submission_reference',
  form_submission_data: 'submission_data',

  /*New*/
  data_json: "data_json",

  annotation_timestamp: "annotation_timestamp"

  
};

/* Firebase */
/* These fields are used as well for the names in the code */
export const pDB = {
  /* Collections */
  web_management: "web-management",
  users_collection: "users",
  users_admin_collection: "users-admin",
  users_feedback: "users-feedback",
  signs_collection: "signs-inference",
  collaborator_collection: "signs-collaborations",
  /* Fields */
  id: "id",
  sign_id: "sign_id",
  name: "name",
  def: "definition",
  url_sign: "url_vid_sign",
  url_def: "url_vid_definition",
  // counter: "counter",
  /* User fields */
  favs: "favorites",
  history: "history",
  theme: "theme",
  /* User-admin filds */
  datasetBuilder: "dataserBuilder",
  role: "role",
  signer_label: "signer_label",
  /* Extra */
  prob: "prob",
  date: "date",
};

export const pDB_user_roles = {
  none: -1,
  invitated: 0,
  registered: 1,
  collaborator: 2,
  annotator: 3,
  admin: 9,
};

export const convert_role_string_to_index = (role) => {
  switch (role) {
    case 'INVITADO':
      return pDB_user_roles.invitated;
    case 'REGISTRADO':
      return pDB_user_roles.registered;
    case 'COLABORADOR':
      return pDB_user_roles.collaborator;
    case 'ANOTADOR':
      return pDB_user_roles.annotator;
    case 'ADMIN':
      return pDB_user_roles.admin;
    default:
      return -1;
    }
}; 

export const convert_role_index_to_string = (index) => {
  switch (index) {
    case pDB_user_roles.invitated:
      return 'INVITADO';
    case pDB_user_roles.registered:
      return 'REGISTRADO';
    case pDB_user_roles.collaborator:
      return 'COLABORADOR';
    case pDB_user_roles.annotator:
      return 'ANOTADOR';
    case pDB_user_roles.admin:
      return 'ADMIN';
    default:
      return 'INVALID_ROLE';
  }
};

export const pGuest = {
  email: "invitado@gmail.com",
  passwd: "invitado",
};

/* Face status */
export const pStatus = {
  init: 0,
  runTf: 1,
  faceDetected: 2,
  countdown: 3,
  record: 4,
  rep: 5,
  rep_end: 6,
  error: 14,
};

/* DatasetBuilder Web status */
export const pDatasetBuilderStates = {
  init: 0, // Init
  init_request: 1, // Send request
  runVideo: 2, // Running video
  idle: 3, // Video run ok and end
};

/* TensorFlow.js */
export const pTensorFlow = {
  maxFaces: 1,
  scoreThreshold: 0.8,
  ts: 100, // ms
};

export const pGalibo = {
  width: 170,
  height: 140,
  heightY: 4.2,
  /* Style */
  color: "white",
  strokeWidth: 2,
  /* Face detection */
  iouThreshold: 0.4,
};

export const pURLs = {
  app: "https://www.notion.so/SignaMed-b35927a233894b1088bb09434a6d6ca3",
  help: "https://www.notion.so/SignaMed-b35927a233894b1088bb09434a6d6ca3",
};

/* Help Dialog */
export const pHelpURLs = {
  main: "https://signamed.uvigo.es/",
  signamed: "https://signamed.uvigo.es/signamed/#diccionario-accesible-en-lse",
  tecnologia: "https://signamed.uvigo.es/signamed/#tecnologia-subyacente",
  funcionalidad: "https://signamed.uvigo.es/signamed/#funcionalidad",
  terminos_uso: "https://signamed.uvigo.es/signamed/#terminos-y-condiciones-de-uso",
  privacidad: "https://signamed.uvigo.es/signamed/#politica-de-privacidad",
  form_help: "https://signamed.uvigo.es/contacto/"
};

/* Bug Dialog */
export const pBugURLs = {
  github_issues: "https://github.com/speechsigns/signamed-public/issues",
};

export const pLoginTab = {
  login: 0,
  register: 1,
};

export const pDialogTab = {
  sign: 0,
  def: 1,
  examples: 2,
  feedback: 10,
  none: -1,
};

export const pDialogProfileTab = {
  info: 0,
  activity: 1,
  configuration: 2,
  message: 3,
};

export const pRecordsTab = {
  resume: 0,
  evaluation: 1,
};

export const pRecordsVideoTab = {
  user: 0,
  reference: 1,
};

export const pCameraTesterTab = {
  none: -1,
  position: 0,
  video: 1,
};

export const pCameraTesterState = {
  NONE: -1,
  POSE: 0,
  PRE_VID_REF: 1,
  VID_REF: 2,
  POST_VID_REF: 3,
  RECORDING: 4
}


export const pTeamHomeTab = {
  info: 0,
  aula: 1,
  activity: 2,
  invitation: 3,
  message: 4,
};

export const pTeamActivityViewTab = {
  videos: 0,
  statistics: 1,
};

export const pRecordsRegisterTab = {
  videos: 0,
  submission: 1,
};

export const pDialogVersusMachine = {
  resumeTab: 0,
  detailTab: 1,
  rankingTab: 2,
};

export const pDialogVersusMachineRanking = {
  hitsRanking: 0,
  perfectScoreRanking: 1,
  timePerfectScoreRanking: 2,
  repetitionsPerfectScoreRanking: 2,
};

export const pDialogMoveYourSkeleton = {
  infoTab: 0,
  rankingTab: 1,
};

export const pDialogMoveYourSkeletonRanking = {
  tempRanking: 0,
  consolidatedRanking: 1
};

export const pTeamsRanking = {
  totalPoints: 0,
  videPoints: 1,
  lexicoPoints: 2
};

export const pDataProvider = {
  /* Name of temporal files .json */
  json_lemma: "JSON_LEMMA",
  json_meaning: "JSON_MEANING",
  json_gloss: "JSON_GLOSS",
  json_sentence: "JSON_SENTENCE",
  json_answer: "JSON_ANSWER",
  json_question: "JSON_QUESTION",

  /* Common parameter*/
  id: "_id",
  lastModified: "lastModified",

  /* Arrays references or strings */
  arr_meanings: "arr_meanings",
  arr_variants: "arr_variants",
  arr_lemmas: "arr_lemmas",
  arr_relatedTo: "arr_relatedTo",
  arr_glosses: "arr_glosses",
  arr_similarTo: "arr_similarTo",
  arr_equalTo: "arr_equalTo",
  arr_comments: "arr_comments",

  label: "label",
  visibility: "visibility", // [true, false]
  accesible: "accesible", // ['RED', 'YELLOW', 'GREEN']

  url_vid_default: "url_vid_default",
  url_vid_definition: "url_vid_definition",
  definition: "definition",
  dir_vid_default: "dir_vid_default",
  dir_vid_definition: "dir_vid_definition",

  dir_vid_question: "dir_vid_question",
  dir_vid_answer: "dir_vid_answer",

  uid: "uid",
  url_vid_sign: "url_vid_sign",
  dir_vid_sign: "dir_vid_sign",
  type: "type",
  model: "model",

  arr_sentences: "arr_sentences",
  url_vid_sentence: "url_vid_sentence",
  dir_vid_sentence: "dir_vid_sentence",
  url_json_sentence: "url_json_sentence",
  dir_json_sentence: "dir_json_sentence",

  zone: 'zone',
  text: 'text',
  substitle: 'substitle',
  dir_vid_question: 'dir_vid_question',
  url_vid_question: 'url_vid_question',
  arr_answers: 'arr_answers',
    
  dir_vid_answer: 'dir_vid_answer',
  url_vid_answer: 'url_vid_answer',
  arr_questions: 'arr_questions',


  dir_vid_donate_sentence: "vid_donate_sentence",
  dir_vid_donate_fingerspelling: "vid_donate_fingerspelling",


  /* Default new variations */
  new_sign: "new_sign",

  /* Carousel of examples */
  carousel_number_max_examples: 5,

  
  dir_vid_versusKeypoints: "VersusMachine/keypoints/",
  dir_vid_versusOverlay: "VersusMachine/overlay/",

  // dir_vid_versusKeypoints2: "VersusMachine2/keypoints/",
  // dir_vid_versusOverlay2: "VersusMachine2/overlay/"
};

export const pDataOrigin = {
  unknown_LABEL: 'UNKNOWN',
  inference_LABEL: 'INFERENCE',
  collaboration_LABEL: 'COLLABORATION',
  donate_sign_LABEL: 'DONATE_SIGN',  
  moveYourSkeleton_LABEL: 'MOVE_YOUR_SKELETON',     
  newVariant_LABEL: 'NEW_VARIANT',   
  newSign_LABEL: 'NEW_SIGN',   
  newDefinition_LABEL: 'NEW_DEFINITION',   
  mediapipe_LABEL: 'MEDIAPIPE',  
}

export const pDataOriginLabel = {
  unknown_LABEL: 'Desconocido',
  inference_LABEL: 'Búsqueda',
  collaboration_LABEL: 'Colaboración',
  donate_sign_LABEL: 'Dona Signo',
  moveYourSkeleton_LABEL: 'Mueve tu esqueleto',              
  newVariant_LABEL: 'Variante nueva', 
  newSign_LABEL: 'Signo nuevo', 
  newDefinition_LABEL: 'Definición nueva', 
}


export const pDataPermission = {
  VIDEO: 'VIDEO',
  KP: 'KP',
  NONE: 'NONE',   
}

export const pDataPermissionLabel = {
  VIDEO: 'VÍDEO',
  KP: 'ESQUELETO',
  NONE: 'NO PERMITIR',            
}

export const pDataTypeVideo = {
  video_RGB: 'RGB',
  video_KEYPOINTS: 'KP',
  video_OVERLAY: 'OVERLAY',
}

export const pSubmissionType = {
  submission_NEW_SIGN: 'NEW_SIGN',
  submission_NEW_DEFINITION: 'NEW_DEFINITION',
  submission_NEW_VARIANT: 'NEW_VARIANT',
}





const default_width = '20%';
const default_height = '10%';
const btn_combination_init  = [true, false, false, false, false, false];
const btn_combination_record = [false, true, true, false, false, false];
const btn_combination_result = [false, false, false, true, true, true];

export const pVisualControl = {
    Btn_Grabar : { 
        id_action: 0,
        label : "Record",
        top: '2%' , 
        left: '30%',
        height: default_height,
        width: '40%',
        showNext : btn_combination_record,
        repeat : false
    },
    Btn_Repetir : { 
        id_action: 1,
        label : "Repeat",
        top: '2%' , 
        left: '2%',
        height: default_height,
        width: default_width,
        showNext : btn_combination_init,
        repeat : false
    },
    Btn_Enviar : { 
        id_action: 2,
        label : "Send",
        top: '2%' , 
        left: '78%',
        height: default_height,
        width: default_width,
        showNext : btn_combination_result,
        repeat : false
    },
    Btn_Signo_Definicion : { 
        id_action: 3,
        label : "Definition",
        top: '2%' , 
        left: '78%',
        height: default_height,
        width: default_width,
        showNext : btn_combination_result,
        repeat : false
    },
    Btn_Siguiente : { 
        id_action: 4,
        label : "Next",
        top: '45%' , 
        left: '78%',
        height: default_height,
        width: default_width,
        showNext : btn_combination_result,
        repeat : true
    },
    Btn_OK : { 
        id_action: 5,
        label : "Continue",
        top: '85%' , 
        left: '78%',
        height: default_height,
        width: default_width,
        showNext : btn_combination_init,
        repeat : false
    }
}

const btn_visualizer_default_width = '25%';
const btn_visualizer_default_height = '15%';
const btn_visualizer_combination_init  = [true, true, true, true, false, false];
const btn_visualizer_combination_result = [false, false, false, false, true, true];

export const pVisualizerControl = {
    Btn_Atras : { 
        id_action: 10,
        label : "SUBIR",
        top: '2%' , 
        left: '2%',
        height: btn_visualizer_default_height,
        width: btn_visualizer_default_width,
        showNext : btn_visualizer_combination_init,
        repeat : true
    },
    Btn_Siguiente : { 
        id_action: 11,
        label : "BAJAR",
        top: '35%' , 
        left: '2%',
        height: btn_visualizer_default_height,
        width: btn_visualizer_default_width,
        showNext : btn_visualizer_combination_init,
        repeat : true
    },
    Btn_Aleatorio : { 
        id_action: 12,
        label : "RANDOM",
        top: '2%' , 
        left: '73%',
        height: btn_visualizer_default_height,
        width: btn_visualizer_default_width,
        showNext : btn_visualizer_combination_init,
        repeat : false
    },
    Btn_Abrir_Dialog : { 
        id_action: 13,
        label : "VER",
        top: '2%' , 
        left: '38%',
        height: btn_visualizer_default_height,
        width: btn_visualizer_default_width,
        showNext : btn_visualizer_combination_result,
        repeat : false
    },
    Btn_Signo_Definicion : { 
        id_action: 14,
        label : "TAB",
        top: '2%' , 
        left: '73%',
        height: btn_visualizer_default_height,
        width: btn_visualizer_default_width,
        showNext : btn_visualizer_combination_result,
        repeat : false
    },
    Btn_OK : { 
        id_action: 15,
        label : "OK",
        top: '35%' , 
        left: '73%',
        height: btn_visualizer_default_height,
        width: btn_visualizer_default_width,
        showNext : btn_visualizer_combination_init,
        repeat : false
    }
}